import { Component, inject, Input } from '@angular/core';

import { PegaChannelName } from '@ap/pega';
import { ApWebContainerService, NativeProcessStatus } from '@ap/web-container';

import { DistributionChannelType } from '../base-starter-app';
import { BaseStarterAppDirective } from '../base-starter-app/base-starter-app.directive';

import { ApPegaEventsMobiel } from './starter-app-mobiel.model';

@Component({
    selector: 'pega-starter-app-mobiel',
    templateUrl: './starter-app-mobiel.component.html',
    standalone: false
})
export class StarterAppMobielComponent extends BaseStarterAppDirective implements ApPegaEventsMobiel {
    @Input() public override apPegaChannel: PegaChannelName = PegaChannelName.MOBIEL;
    @Input() public confirmBeforeExit = false;
    @Input() public forceNativeBackButton = true;

    protected readonly apWebcontainerService = inject(ApWebContainerService);

    protected distributionChannelType: DistributionChannelType = DistributionChannelType.MOBIEL;

    public onClose(status: NativeProcessStatus): void {
        this.apWebcontainerService.finishProcess(status);
    }
}
